import React from 'react';

const AboutPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">About Us</h1>
      <div className="bg-white rounded-xl shadow p-8 space-y-5 text-gray-600 leading-relaxed">
        <p><span className="font-semibold text-gray-800">SASTA DEAL PRIVATE LIMITED</span> is the company behind Sasta Fashions — an e-commerce platform offering fashion products and lifestyle essentials across India.</p>
        <p>We are committed to providing quality products at affordable prices, with a seamless shopping experience for every customer.</p>
        <p>Our collection spans Women's, Men's, and Kids' fashion — from ethnic wear to western styles, everyday casuals to festive outfits.</p>
        <p>We believe fashion is for everyone, and our mission is to make great style accessible to all.</p>
        <div className="border-t pt-5 space-y-1">
          <p><span className="font-semibold text-gray-800">Company:</span> SASTA DEAL PRIVATE LIMITED</p>
          <p><span className="font-semibold text-gray-800">Email:</span> sastadealpvt@gmail.com</p>
          <p><span className="font-semibold text-gray-800">Address:</span> 80, MADINA COMPLEX, Radhaballavpur Road, Bangiya GraminVikash Bank, Turkakashba, PaschimMedinipur, West Bengal - 721445</p>
        </div>
      </div>
    </div>
  </div>
);

export default AboutPage;
